import "./Hero.css";

import React, { useEffect, useState } from 'react'
import IntroImg from "../assets/img-1.jpg";
import { Link } from "react-router-dom";
 
const Hero = () => {
    const [loopNum, setLoopNum] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const toRotate = ["Software Engineer", "Web Developer", "UI/UX Designer"];
    const [text, setText] = useState('');
    const [delta, setDelta] = useState(300 - Math.random() * 100);
    const period = 150;

    useEffect(() => {
        let ticker = setInterval(() => {
            tick();
        }, delta)

        return () => { clearInterval(ticker)};
    }, [text])

    const tick = () => {
        let i = loopNum % toRotate.length;
        let fullText = toRotate[i];
        let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

        setText(updatedText);

        if(isDeleting)
        {
            setDelta(prevDelta => prevDelta/2)
        }

        if(!isDeleting && updatedText === fullText)
        {
            setIsDeleting(true);
            setDelta(period);
        }
        else if(isDeleting && updatedText === '')
        {
            setIsDeleting(false);
            setLoopNum(loopNum + 1);
            setDelta(100);
        }
    }

return (
    <div className="hero">
        <div className="mask">
            <img className="intro-img" src={IntroImg} alt="IntroImg"/>     
        </div>
        <div className="content">
            <p> Hi, I'm Moudisa</p>
        
            <h1>{text}</h1>
            <h4>Welcome to my digital realm!</h4>
            
            <Link to="https://moudisa-bucket-1.s3.ap-south-1.amazonaws.com/Resume/MoudisaResume2024.pdf" className="btn">Download Resume</Link>
            
        </div>
    
    </div>
)
}

export default Hero
 